import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px" itemprop="name">Kan kulsyre flasken tåle at ligge ned?</Heading1>
                  <hr />
                  <Paragraph>
                    <Bold>Kort svar: </Bold>
                  </Paragraph>
                  <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <Paragraph>
                      <Bold>Ja</Bold> under transport er det uden betydning hvordan den vender.<br />
                      <Bold>Ja</Bold> under brug kan den også godt ligge ned, men dog gerne med hanen lidt højere end bunden af flasken.
                    </Paragraph>
                  </Div>
                  <Paragraph>
                    <Bold>Uddybende svar: </Bold>
                  </Paragraph>
                  <Paragraph>
                    Når kulsyreflasken er fuld, indeholder den både gas og væske.
                    Efterhånden som man bruger af den, fordamper væsken.
                    Trykket i flasken er konstant så længe der er væske tilbage.
                    Først når flasken er tæt ved at være tom falder trykket lineært fra ca. 70 bar til 0.
                  </Paragraph>
                  <Paragraph>
                    Hvis man bruger en fuld flaske med udtaget nedad, vil der ikke komme gas(co2), men væske (tøris) ud, derfor skal udtaget være placeret bare lidt højere en bunden af flasken så overfladen af den flydende co2 er under udtaget.
                  </Paragraph>
                  <Paragraph><LinkStyled to="/kulsyre">Læs mere om kulsyreflasker her</LinkStyled></Paragraph>

                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
